export default __webpack_public_path__ + "static/media/wie.a98e0138.png";